import { useEffect, useState, type JSX } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api, type TicketPreview } from '../api.js';
import { loadPreviewPayload, TicketPreviewView } from '../components/TicketPreview.js';
import { Logo } from '../components/Icon.js';
import { BRAND } from '../branding.js';

/**
 * Предпросмотр билета в отдельной вкладке: открывается кнопкой в блоке
 * «Событие билета» карточки продукта. Поля формы — из localStorage по ключу
 * ?k=, сама сборка — POST /admin/api/ticket-preview (нужен вход в админку).
 */
export function TicketPreviewPage(): JSX.Element {
  const [params] = useSearchParams();
  const key = params.get('k') ?? '';
  const [preview, setPreview] = useState<TicketPreview | null>(null);
  const [eventName, setEventName] = useState('');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const payload = key ? loadPreviewPayload(key) : null;
    if (!payload) {
      setErr('Предпросмотр устарел. Откройте его снова кнопкой в карточке продукта.');
      return;
    }
    setEventName(typeof payload.eventName === 'string' ? payload.eventName : '');
    document.title = 'Предпросмотр билета';
    api
      .ticketPreview(payload)
      .then(setPreview)
      .catch((e: Error & { status?: number }) =>
        setErr(e.status === 401 ? 'Войдите в админку и откройте предпросмотр снова.' : e.message),
      );
  }, [key]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '28px 20px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', display: 'grid', gap: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo size={22} />
          <div style={{ fontWeight: 600, fontSize: 15 }}>{BRAND.name}</div>
        </div>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 600, letterSpacing: -0.3 }}>Предпросмотр билета</h1>
          {eventName && (
            <div style={{ color: 'var(--fg-subtle)', fontSize: 14, marginTop: 4 }}>
              <bdi>{eventName}</bdi>
            </div>
          )}
          <div style={{ color: 'var(--fg-subtle)', fontSize: 12.5, marginTop: 6 }}>
            Собрано по полям формы на момент нажатия, в том числе несохранённым. Поменяли поля — нажмите кнопку
            предпросмотра в карточке продукта ещё раз.
          </div>
        </div>
        <div className="card" style={{ padding: 20 }}>
          {err && <div style={{ color: 'var(--danger-fg)', fontSize: 14 }}>{err}</div>}
          {!err && !preview && <div style={{ color: 'var(--fg-subtle)', fontSize: 14 }}>Собираем…</div>}
          {preview && <TicketPreviewView preview={preview} />}
        </div>
      </div>
    </div>
  );
}
